function parseCode(search: string): string {
	const parsedHash = new URLSearchParams(search);
	// We asumme this exists
	return parsedHash.get('code') as string;
}

function parsePath(search: string): string {
	const parsedHash = new URLSearchParams(search);

	// We asumme this exists
	return parsedHash.get('state') as string;
}

export default {
	parseCode,
	parsePath,
};
